<template>
  <page>
    <div>
      <v-card>
        <form>
          <message :messages="messages"></message>
          <v-expansion-panels v-model="panel1" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Selection Criteria
              </div>
            </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xs6>
                        <v-autocomplete :items="reportTypes" v-model="form.reportType" :label="label.reportType" item-text="label" item-value="value" data-vv-name="reportType" :data-vv-as="label.reportType" :error-messages="errors.collect('reportType')" v-validate="'required'" @change="doChgReportType($event)"></v-autocomplete>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs6>
                        <v-text-field v-model="form.branch" :label="label.branch" :error-messages="errors.collect('branch')" data-vv-name="branch" :data-vv-as="label.branch" append-icon="mdi-magnify" @click:append="getHelpList('branch')" readonly></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field v-model="form.fund" :label="label.fund" :error-messages="errors.collect('fund')" data-vv-name="fund" :data-vv-as="label.fund" append-icon="mdi-magnify" @click:append="getHelpList('fund')" readonly></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field v-model="form.suffix" :label="label.suffix" :error-messages="errors.collect('suffix')" data-vv-name="suffix" :data-vv-as="label.suffix" append-icon="mdi-magnify" @click:append="getHelpList('suffix')" readonly></v-text-field>
                      </v-flex>
                      <v-flex xs6 v-if="(form.reportType === 'Chart' || form.reportType === 'GL')">
                        <v-autocomplete :items="acctTypes" v-model="form.acctType" :label="label.acctType" item-text="label" item-value="value" data-vv-name="acctType" :data-vv-as="label.acctType" :error-messages="errors.collect('acctType')" @change="doChange($event)" :disabled="(form.reportType === 'GST' || form.reportType === 'Master')"></v-autocomplete>
                      </v-flex>
                      <v-flex xs6 v-if="(form.reportType === 'Chart' || form.reportType === 'GL')">
                        <v-autocomplete :items="postTypes" v-model="form.postType" :label="label.postType" item-text="label" item-value="value" data-vv-name="postType" :data-vv-as="label.postType" :error-messages="errors.collect('postType')" @change="doChange($event)" :disabled="(form.reportType === 'GST' || form.reportType === 'Master')"></v-autocomplete>
                      </v-flex>
                      <v-flex xs6 v-if="(form.reportType == 'GST')">
                        <v-text-field v-model="form.gstStatus" :label="label.gstStatus" :error-messages="errors.collect('gstStatus')" data-vv-name="gstStatus" :data-vv-as="label.gstStatus" append-icon="mdi-magnify" @click:append="getHelpList('gstStatus')" readonly :disabled="(form.reportType === 'Char' || form.reportType === 'GL' || form.reportType === 'Master')"></v-text-field>
                      </v-flex>
                      <v-flex xs6 v-if="(form.reportType === 'GL' || form.reportType === 'GST')">
                        <v-autocomplete :items="posteds" v-model="form.posted" :label="label.posted" item-text="label" item-value="value" data-vv-name="posted" :data-vv-as="label.posted" :error-messages="errors.collect('posted')" :disabled="(form.reportType === 'Char' || form.reportType === 'Master')"></v-autocomplete>
                      </v-flex>
                      <v-flex xs6 v-if="(form.reportType === 'GL' || form.reportType === 'GST')">
                        <v-text-field v-model="form.batchNo" :label="label.batchNo" :error-messages="errors.collect('batchNo')" data-vv-name="batchNo" :data-vv-as="label.batchNo" v-validate="bchNoValidation" @change="getGlBatchNo()" :disabled="(form.reportType === 'Char' || form.reportType === 'Master')"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          </v-expansion-panels>
          <v-spacer class="mt-3"></v-spacer>
          <v-expansion-panels v-model="panel2" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filter
              </div>
            </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-sm>
                    <v-layout row wrap>
                      <v-flex xs6 v-if="(form.reportType === 'GL' || form.reportType == 'GST')">
                        <cal-picker v-model="form.tranDateFrom" :label="label.tranDateFrom" :data-vv-as="label.tranDateFrom" data-vv-name="tranDateFrom" :error-messages="errors.collect('tranDateFrom')" v-validate="(tranDateFromValidation)" :disabled="(form.reportType === 'Char' || form.reportType === 'Master')"></cal-picker>
                      </v-flex>
                      <v-flex xs6 v-if="(form.reportType === 'GL' || form.reportType == 'GST')">
                        <cal-picker v-model="form.tranDateTo" :label="label.tranDateTo" :data-vv-as="label.tranDateTo" data-vv-name="tranDateTo" :error-messages="errors.collect('tranDateTo')" v-validate="tranDateToValidation"></cal-picker>
                      </v-flex>
                      <v-flex xs6 v-if="(form.reportType === 'GL' || form.reportType == 'GST' || form.reportType === 'Master')">
                        <v-text-field v-model="form.acctYearFrom" :label="label.acctYearFrom" :error-messages="errors.collect('acctYearFrom')" data-vv-name="acctYearFrom" :data-vv-as="label.acctYearFrom" v-validate="(acctYearFromValidation /*, maxAcctYearFromValidation*/ )"></v-text-field>
                      </v-flex>
                      <v-flex xs6 v-if="(form.reportType === 'GL' || form.reportType == 'GST')">
                        <v-text-field v-model="form.acctYearTo" :label="label.acctYearTo" :error-messages="errors.collect('acctYearTo')" data-vv-name="acctYearTo" :data-vv-as="label.acctYearTo" v-validate="acctYearToValidation" :disabled="(form.reportType === 'Master')"></v-text-field>
                      </v-flex>
                      <v-flex xs6 v-if="(form.reportType === 'GL' || form.reportType == 'GST' || form.reportType === 'Master')">
                        <v-text-field v-model="form.acctMonthFrom" :label="label.acctMonthFrom" :error-messages="errors.collect('acctMonthFrom')" data-vv-name="acctMonthFrom" :data-vv-as="label.acctMonthFrom" v-validate="acctMonthFromValidation"></v-text-field>
                      </v-flex>
                      <v-flex xs6 v-if="(form.reportType === 'GL' || form.reportType == 'GST')">
                        <v-text-field v-model="form.acctMonthTo" :label="label.acctMonthTo" :error-messages="errors.collect('acctMonthTo')" data-vv-name="acctMonthTo" :data-vv-as="label.acctMonthTo" v-validate="acctMonthToValidation" :disabled="(form.reportType === 'Master')" ></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field v-model="form.glAcctNoFrom" :label="label.glAcctNoFrom" :error-messages="errors.collect('glAcctNoFrom')" data-vv-name="glAcctNoFrom" :data-vv-as="label.glAcctNoFrom" append-icon="mdi-magnify" @click:append="getGlAcctNo('glAcctNoFrom')"></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field v-model="form.glAcctNoTo" :label="label.glAcctNoTo" :error-messages="errors.collect('glAcctNoTo')" data-vv-name="glAcctNoTo" :data-vv-as="label.glAcctNoTo" append-icon="mdi-magnify" @click:append="getGlAcctNo('glAcctNoTo')"></v-text-field>
                      </v-flex>
                    </v-layout>
                     <v-layout row wrap>
                      <v-flex xs6 v-if="(form.reportType === 'Master')">
                        <v-autocomplete :items="printOpts" v-model="form.printOpt" :label="label.printOpt" item-text="label" item-value="value" data-vv-name="printOpt" :data-vv-as="label.printOpt" :error-messages="errors.collect('printOpt')"></v-autocomplete>
                      </v-flex>
                      <v-flex v-else>
                      </v-flex>
                      <v-flex xs6>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-card>
      <v-flex xs6>
        <v-checkbox color="primary" :label="label.prtRunTimeAE" v-model="form.prtRunTimeAE"></v-checkbox>
      </v-flex>
      <v-flex xs12>
        <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
          <v-icon left dark>mdi-file-export</v-icon>
          {{ label.export }}
        </v-btn>
        <v-btn-toggle dense mandatory v-model="form.format">
          <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
            <span>{{ format.label }}</span>
            <v-icon :color="format.color">{{ format.icon }}</v-icon>
          </v-btn>
        </v-btn-toggle>
      </v-flex>
    </div>

    <v-dialog v-model="helplist" width="900px"   persistent>
      <helplist :apiURI="apiURI" :mode="mode" :param="param" @close="doClose" @doAssign="doAssign($event)"></helplist>
    </v-dialog>

    <v-dialog v-model="acctNoHelpList" width="900px"   persistent>
      <gl-acct-help-list :brn="form.branch" :wAcctNo="wAcctNo" :changeValue="selectedValue" :fund="form.fund" :suffix="form.suffix" :acctType="form.acctType" :postType="form.postType" :acctYr="form.acctYearTo" @close="doCloseAcctNo" @doAssign="doAssignGlAcctNo($event)"></gl-acct-help-list>
    </v-dialog>

  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { reportFormat } from '@/const/report'
import { extractMenu } from '@/utils/extract'
import Helplist from '../Helplist'
import { expandURI } from '@/utils/ajax'
import isAfter from 'date-fns/isAfter'
import { removeTime } from '@/utils/date'
import { parseISO } from 'date-fns'
import GlAcctHelpList from './GlAcctHelpList'

export default {
  data() {
    return {
      label: {
        reportType: 'Type of Report',
        branch: 'Branch',
        fund: 'Fund',
        suffix: 'Suffix',
        acctType: 'Account Type',
        postType: 'Post Type',
        gstStatus: 'GST Status',
        posted: 'Posted',
        batchNo: 'Batch No.',
        tranDateFrom: 'Transaction Date From',
        tranDateTo: 'Transaction Date To',
        acctYearFrom: 'Accounting Year From',
        acctYearTo: 'Accounting Year To',
        acctMonthFrom: 'Accounting Month From',
        acctMonthTo: 'Accounting Month To',
        glAcctNoFrom: 'GL Account No. From',
        glAcctNoTo: 'GL Account No. To',
        printOpt: 'Print Option',
        prtRunTimeAE: 'Print Runtime Parameters',
        export: 'Export To',
        format: 'Export Format'
      },
      form: {
        reportType: 'Chart',
        branch: 'All',
        fund: 'All',
        suffix: 'All',
        acctType: 'All',
        postType: 'B',
        gstStatus: 'All',
        posted: 'Y',
        batchNo: '0',
        tranDateFrom: '',
        tranDateTo: '',
        acctYearFrom: '',
        acctYearTo: '',
        acctMonthFrom: '1',
        acctMonthTo: '12',
        glAcctNoFrom: '',
        glAcctNoTo: '',
        printOpt: 'Both',
        prtRunTimeAE: true,
        format: undefined,
        glTranBchNoFound: false,
        defAcctYr: '',
        selectedBranch: '',
        selectedFund: '',
        selectedSuffix: '',
        selectedAcctType: '',
        selectedGstStat: ''

      },
      reportTypes: [
        { label: 'Chart of Accounts', value: 'Chart' },
        { label: 'GL Report', value: 'GL' },
        { label: 'GL GST List', value: 'GST' },
        { label: 'GL Master List', value: 'Master' }
      ],
      acctTypes: [
        { label: 'Asset', value: 'A' },
        { label: 'Expense', value: 'E' },
        { label: 'Income', value: 'I' },
        { label: 'Liabilty', value: 'L' },
        { label: 'All', value: 'All' }
      ],
      postTypes: [
        { label: 'Both', value: 'B' },
        { label: 'Posting', value: 'P' },
        { label: 'Summary', value: 'S' }
      ],
      gstStatuses: [],
      posteds: [
        { label: 'Both', value: 'B' },
        { label: 'Yes', value: 'Y' },
        { label: 'No', value: 'N' }
      ],
      printOpts: [
        { label: 'Both', value: 'Both' },
        { label: 'Actual Figures', value: 'A' },
        { label: 'Budget Figures', value: 'B' }
      ],
      supportedFormat: [],
      submitting: false,
      menu: {},
      helplist: false,
      apiURI: '',
      mode: '',
      param: '',
      acctNoHelpList: false,
      selectedValue: '',
      wAcctNo: '',
      toggleFilters: [true],
      panel1: [0],
      panel2: [0]
    }
  },
  methods: {
    async doInit() {
      await this.$store.dispatch('accountReportsInit')
      const apiURI = this.rptMenu.acctGL
      const result = await this.$http.get(apiURI)
      if (result.data) {
        const { data } = result.data
        if (data) {
          this.supportedFormat = data.format
          this.menu = extractMenu(result.data._links)
        }
      }
      this.getCompany()
      this.doChgReportType()
    },
    doChgReportType() {
      if (this.form.reportType === 'Master') {
        this.form.acctYearTo = this.form.acctYearFrom
        this.form.acctMonthTo = this.form.acctMonthFrom
      } else {
        this.getCompany()
      }
    },
    getHelpList(fieldName) {
      this.mode = fieldName
      if (fieldName === 'branch') {
        this.apiURI = this.menu.getBranchList
        this.param = this.form.branch
      } else if (fieldName === 'fund') {
        this.apiURI = this.menu.getFundList
        this.param = this.form.fund
      } else if (fieldName === 'suffix') {
        this.apiURI = this.menu.getAcctNoSfxList
        this.param = this.form.suffix
      } else if (fieldName === 'gstStatus') {
        this.apiURI = this.menu.getGstStatusList
        this.param = this.form.gstStatus
      }
      this.helplist = true
    },
    doAssign(Obj) {
      switch (this.mode) {
        case 'branch': this.form.branch = ''
          this.form.branch = Obj.finalSelectedItems.toString()
          break
        case 'fund': this.form.fund = ''
          this.form.fund = Obj.finalSelectedItems.toString()
          break
        case 'suffix': this.form.suffix = ''
          this.form.suffix = Obj.finalSelectedItems.toString()
          break
        case 'gstStatus': this.form.gstStatus = ''
          this.form.gstStatus = Obj.finalSelectedItems.toString()
          break
      }
    },
    doAssignGlAcctNo(Obj) {
      let from = Obj.from
      switch (from) {
        case 'glAcctNoFrom':
          this.form.glAcctNoFrom = ''
          this.form.glAcctNoFrom = Obj.selectedItem
          break
        case 'glAcctNoTo':
          this.form.glAcctNoTo = ''
          this.form.glAcctNoTo = Obj.selectedItem
          break
      }
    },
    doClose() {
      this.helplist = false
    },
    getGlAcctNo(fieldName) {
      this.acctNoHelpList = true
      this.wAcctNo = fieldName
    },
    doChange(data) {
      this.selectedValue = data
    },
    doCloseAcctNo() {
      this.acctNoHelpList = false
    },
    async getGlBatchNo() {
      this.form.glTranBchNoFound = false
      if (this.form.posted === 'Y' && (this.form.batchNo !== '' && parseInt(this.form.batchNo) > 0)) {
        const apiUrl = this.menu.getGlBchNo
        if (apiUrl) {
          try {
            const requestParams = {
              bchNo: this.form.batchNo
            }
            const result = await this.$http.get(expandURI(apiUrl, requestParams))
            const { data } = result.data
            if (data) {
              this.form.glTranBchNoFound = true
            }
            return true
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.notify(data)
            }
            return false
          }
        } else {
          this.$toast.error('The request failed because it is trying to execute an invalid API url.')
          return false
        }
      }
    },
    async getCompany() {
      const apiURI = this.menu.getCompany
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.form.tranDateFrom = new Date(data.company.currAcctYr, 0, 1)
          this.form.tranDateTo = new Date(data.company.currAcctYr, 11, 31)
          this.form.acctYearFrom = data.company.currAcctYr
          this.form.acctYearTo = data.company.currAcctYr
          this.form.defAcctYr = data.company.currAcctYr
          /*
          this.reportForm.acctYr = data.company.currAcctYr
          this.defAcctYr = data.company.currAcctYr
          this.maxAcctYr = data.company.currAcctYr + 1
          */
        }
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.form)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  created() {
    this.doInit()
    this.$validator.extend('batchNo', {
      getMessage(field, args) {
        return 'Invalid number.'
      },
      validate(value, args) {
        return false
      }
    })

    this.$validator.extend('valTranDateFrom', {
      getMessage(field, args) {
        return 'Transaction Date From must be equal or less than Transaction Date To'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranDate = args[0]
        if (tranDate) {
          return !(isAfter(removeTime(value), removeTime(tranDate)))
        }
      }
    })

    this.$validator.extend('valTranDateTo', {
      getMessage(field, args) {
        return 'Transaction Date To must be equal or greater than Transaction Date From'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranDate = args[0]
        if (tranDate) {
          return !(isAfter(removeTime(tranDate), removeTime(value)))
        }
      }
    })

    this.$validator.extend('valMinDate', {
      getMessage(field, args) {
        return 'Date must be equal or greater than 01/01/2000'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranDate = args[0]
        if (tranDate) {
          return !(isAfter(removeTime(tranDate), removeTime(value)))
        }
      }
    })

    this.$validator.extend('valMaxDate', {
      getMessage(field, args) {
        return 'Date must be equal or less than 01/01/2070'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranDate = args[0]
        if (tranDate) {
          return !(isAfter(removeTime(value), removeTime(tranDate)))
        }
      }
    })

    this.$validator.extend('acctYrFromDate', {
      getMessage(field, args) {
        return 'Accounting Year From must be equal or less than Accounting Year To'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var acctYrFrom = args[0]
        if (parseInt(acctYrFrom) < parseInt(value)) {
          return false
        } else {
          return true
        }
      }
    })

    this.$validator.extend('acctYrToDate', {
      getMessage(field, args) {
        return 'Accounting Year To must be equal or greater than Accounting Year From'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var acctYrFrom = args[0]
        if (parseInt(acctYrFrom) > parseInt(value)) {
          return false
        } else {
          return true
        }
      }
    })

    this.$validator.extend('maxAcctYrFromDate', {
      getMessage(field, args) {
        return 'Accounting Year From must be equal or less than 1 Accounting Year'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var acctYrFrom = args[0]
        if (parseInt(acctYrFrom) < parseInt(value)) {
          return false
        } else {
          return true
        }
      }
    })

    this.$validator.extend('acctMthFrom', {
      getMessage(field, args) {
        return 'Accounting Month From must be equal or greater than Accounting Month To'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var acctMthFrom = args[0]
        if (parseInt(value) > parseInt(acctMthFrom)) {
          return false
        } else {
          return true
        }
      }
    })

    this.$validator.extend('acctMthTo', {
      getMessage(field, args) {
        return 'Accounting Month To must be equal or greater than Accounting Month From'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var acctMthTo = args[0]
        if (parseInt(acctMthTo) > parseInt(value)) {
          return false
        } else {
          return true
        }
      }
    })

    this.$validator.extend('start_after_today', {
      getMessage(field, args) {
        return `The ${field} cannot be later than the date of application.`
      },
      validate(value, args) {
        if (value) {
          const today = removeTime(new Date())
          const tomorrow = new Date(today)
          tomorrow.setDate(tomorrow.getDate() + 1)
          const startDate = removeTime(value)
          return (isAfter(tomorrow, startDate))
        } else return true
      }
    })

    this.$validator.extend('acctYearMinYear', {
      getMessage(field, args) {
        return 'Accounting year must be after 1999'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranDate = args[0]
        if (tranDate) {
          return !(isAfter(removeTime(tranDate), removeTime(value)))
        }
      }
    })

    this.$validator.extend('acctYearMaxYear', {
      getMessage(field, args) {
        return 'Date must be equal or less than the new financial year'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranDate = args[0]
        if (tranDate) {
          return !(isAfter(removeTime(value), removeTime(tranDate)))
        }
      }
    })
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.accountReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    bchNoValidation() {
      if (this.form.glTranBchNoFound === false && this.form.posted === 'Y' && (this.form.batchNo !== '' && parseInt(this.form.batchNo) > 0)) {
        return 'entry|numeric|mask_min_value:0|batchNo:' + this.form.batchNo
      } else {
        return ''
      }
    },
    tranDateFromValidation() {
      var minDate = '2000-01-01'
      var maxDate = '2069-12-31'
      if (this.form.tranDateFrom !== '' && this.form.tranDateFrom !== null) {
        return 'entry|valTranDateFrom:' + this.form.tranDateTo + '|valMinDate:' + parseISO(minDate) + '|valMaxDate:' + parseISO(maxDate)
      } else {
        return ''
      }
    },
    tranDateToValidation() {
      if (this.form.tranDateTo !== '' && this.form.tranDateTo !== null) {
        return 'entry|start_after_today|valTranDateTo:' + this.form.tranDateFrom
      } else {
        return ''
      }
    },
    dateMinValidation() {
      var minDate = '2000-01-01'

      if (this.form.tranDateTo !== '' && this.form.tranDateTo !== null) {
        return 'entry|valMinDate:' + parseISO(minDate)
      } else {
        return ''
      }
    },
    dateMaxValidation() {
      var minDate = '2069-12-31'

      if (this.form.tranDateTo !== '' && this.form.tranDateTo !== null) {
        return 'entry|valMaxDate:' + parseISO(minDate)
      } else {
        return ''
      }
    },
    acctYearFromValidation() {
      if (this.form.acctYearFrom !== '') {
        let validation = 'entry|numeric|max:4'
        if (this.form.reportType !== 'Master') {
          validation = validation + '|acctYrFromDate:' + this.form.acctYearTo + '|maxAcctYrFromDate:' + parseInt(this.form.defAcctYr + 1)
        }
        return validation
      } else {
        return ''
      }
    },
    acctYearToValidation() {
      if (this.form.acctYearTo !== '') {
        return 'entry|numeric|max:4|acctYrToDate:' + this.form.acctYearFrom + '|maxAcctYrFromDate:' + parseInt(this.form.defAcctYr + 1)
      } else {
        return ''
      }
    },
    maxAcctYearFromValidation() {
      if (this.form.acctYearFrom !== '') {
        return 'entry|numeric|max:4|maxAcctYrFromDate:' + parseInt(this.form.defAcctYr)
      } else {
        return ''
      }
    },
    acctMonthFromValidation() {
      if (this.form.acctMonthFrom !== '') {
        let validation = 'entry|numeric|max:2|mask_max_value:13|mask_min_value:1'
        if (this.form.reportType !== 'Master') {
          validation = validation + '|acctMthFrom:' + this.form.acctMonthTo
        }
        return validation
      } else {
        return ''
      }
    },
    acctMonthToValidation() {
      if (this.form.acctMonthTo !== '') {
        return 'entry|numeric|max:2|mask_max_value:13|mask_min_value:1|acctMthTo:' + this.form.acctMonthFrom
      } else {
        return ''
      }
    }
  },
  watch: {
    'supportedList': function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.form.format = value[0].value
      }
    }
  },
  mixins: [
    MessageMixin
  ],
  components: {
    Helplist,
    GlAcctHelpList
  }
}

</script>
